import React, { useCallback, useMemo, useState } from 'react';
import { AppButton, Box, Dropdown, OptionKey, RawButton, SearchInput, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import CheckboxDropdownGroup from '../../CheckboxDropdownGroup';
import { usePermissionsListQuery } from '../../queries';
interface Props {
  values: OptionKey[];
  onChangeValues: (values: OptionKey[]) => void;
}


const StyledText = styled(Text)`
  &:hover {
    color: ${({ theme }) => theme.colors.danger}
  }
`;

export const RolesPermissionDropdown: React.FC<Props> = ({ values, onChangeValues }) => {
  const [currentValues, setCurrentValues] = useState<OptionKey[]>(values);
  const [isSelected, setIsSelected] = useState(false);
  const [searchString, setSearchString] = useState('');

  const [expanded, setExpanded] = useState(false);

  const { groups, options } = usePermissionsListQuery({ 
    searchString
  });
  const handleReset = useCallback(() => {
    onChangeValues([]);
    setCurrentValues([]);
  }, [onChangeValues]);

  const currentTitle = useMemo(() => {
    if (values.length) {
      return values.map((value) => options.find((option) => option.key === value)?.name).join(', ');
    }
    return 'N/A';
  }, [options, values]);

  const handleCancel = useCallback(() => {
    setExpanded(false);
    setCurrentValues(values);
  }, [values]);

  const handleApply = useCallback(() => {
    onChangeValues(currentValues);
    setExpanded(false);
  }, [currentValues, onChangeValues]);
  return (
    <Box width="240px">
      <Dropdown
        placeholder="Placeholder"
        isClickOutside={false}
        testId='role_permission'
        prefix="Permissions"
        expanded={expanded}
        title={(
          <Text color="textAccent" truncate>
            {currentTitle}
          </Text>
        )}
        onSetExpanded={setExpanded}
        contentStyles={{
          elevation: 'active',
          style: {
            right: '',
            minWidth: '340px',
          },
        }}
      >
        <Box data-testid="permission-dropdown_content" direction="column" width={{ min: '340px' }}>
          <Box pad="m" direction="column">
            <SearchInput value={searchString} placeholder="Search" onChange={setSearchString} />
            <Box direction="row" margin={{ top: 'm' }}>
              <RawButton onClick={() => setIsSelected(false)}>
                <Text weight={400} color={isSelected ? 'textAccent' : 'textBody'}>
                  All Permissions
                </Text>
              </RawButton>
              <RawButton margin={{ left: 's' }} onClick={() => setIsSelected(true)}>
                <Text weight={400} color={isSelected ? 'textBody' : 'textAccent'}>
                  Selected ({currentValues.length || 0})
                </Text>
              </RawButton>
            </Box>
          </Box>
          <Box
            pad="m"
            border={{ side: 'horizontal', size: 'small', color: 'border1' }}
            style={{ overflow: 'auto' }}
            height="290px"
          >
            <div>
              <RawButton onClick={handleReset}>
                <StyledText size="small" color="textSecondary">Reset</StyledText>
              </RawButton>

              {groups.map((group) => (
                <CheckboxDropdownGroup
                  isSelectedMode={isSelected}
                  key={group.id}
                  id={group.id}
                  name={group.name}
                  values={currentValues}
                  onChangeValues={setCurrentValues}
                  options={group.options}
                />
              ))}
            </div>
          </Box>

          <Box pad="m" direction="row">
            <Box margin={{ right: 'spacing6' }}>
              <AppButton testId="permission-dropdown_cancel" width="145px" buttonType="secondary" onClick={handleCancel}>
                Cancel
              </AppButton>
            </Box>
            <Box margin={{ left: 'spacing6' }}>
              <AppButton testId="permission-dropdown_apply" width="145px" onClick={handleApply}>
                Apply
              </AppButton>
            </Box>
          </Box>
        </Box>
      </Dropdown>
    </Box>
  );
};
export default RolesPermissionDropdown;
